import { Component } from '@angular/core';

@Component({
    standalone: true,
    selector: 'app-table-bar-selections',
    templateUrl: './table-bar-selections.component.html',
    styleUrls: ['./table-bar-selections.component.scss'],
    imports: [],
})
export class TableBarSelectionsComponent {}
